<div class="row">
  <div class="column">
    <app-contact-info-card [contactInfo]="enrollment"></app-contact-info-card>
  </div>
  <div class="column two">
    <app-address-info-card [addressInfo]="enrollment"></app-address-info-card>
  </div>
</div>
